import injector from './decorator';
import { IViewModel } from './view-model.d'
import Provider from './Provider';

export {
  IViewModel,
  Provider,
  injector as default
}
